import { render, staticRenderFns } from "./print-invoice.vue?vue&type=template&id=64fc4d76&scoped=true&"
import script from "./print-invoice.vue?vue&type=script&lang=ts&"
export * from "./print-invoice.vue?vue&type=script&lang=ts&"
import style0 from "./print-invoice.vue?vue&type=style&index=0&id=64fc4d76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc4d76",
  null
  
)

export default component.exports